import { jsx } from 'react/jsx-runtime';
import classnames from 'classnames';

var DropzoneOverlayContainer = function DropzoneOverlayContainer(_ref) {
  var visible = _ref.visible,
    fullPage = _ref.fullPage,
    children = _ref.children;
  return jsx("div", {
    className: classnames('cogs-lab', 'cogs-dropzone__overlay-container', visible ? 'cogs-dropzone__overlay-container--visible' : '', fullPage ? 'cogs-dropzone__overlay-container--fullPage' : ''),
    children: children
  });
};
var DropzoneOverlayDefault = function DropzoneOverlayDefault() {
  return jsx("div", {
    className: classnames('cogs-lab', 'cogs-dropzone__overlay')
  });
};

export { DropzoneOverlayContainer, DropzoneOverlayDefault };
